import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteAddress, postUserAddress, putDefaultAddress, putUserAddress } from "src/api/address";
export const QueryKeys = {
    ADDRESS_LIST: "getUserAddress",
    ADDRESS_ADD: "addUserAddress",
    ADDRESS_UPDATE: "updateUserAddress",
    ADDRESS_DELETE: "deleteUserAddress",
    ADDRESS_DEFAULT: "putDefaultAddress"
};
export const useAddressManagement = ()=>{
    const queryClient = useQueryClient();
    const addAddressMutation = useMutation({
        mutationFn: postUserAddress,
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    QueryKeys.ADDRESS_ADD
                ]
            });
        }
    });
    const updateAddressMutation = useMutation({
        mutationFn: putUserAddress,
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    QueryKeys.ADDRESS_UPDATE
                ]
            });
        }
    });
    const deleteAddressMutation = useMutation({
        mutationFn: deleteAddress,
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    QueryKeys.ADDRESS_DELETE
                ]
            });
        }
    });
    const putDefaultAddressMutation = useMutation({
        mutationFn: putDefaultAddress,
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    QueryKeys.ADDRESS_DEFAULT
                ]
            });
        }
    });
    return {
        addAddressAsync: addAddressMutation.mutateAsync,
        updateAddressAsync: updateAddressMutation.mutateAsync,
        deleteAddressAsync: deleteAddressMutation.mutateAsync,
        putDefaultAddressAsync: putDefaultAddressMutation.mutateAsync,
        isAddAddressLoading: addAddressMutation.isLoading,
        isUpdateAddressLoading: updateAddressMutation.isLoading,
        isDeleteAddressLoading: deleteAddressMutation.isLoading,
        isPutDefaultAddressLoading: putDefaultAddressMutation.isLoading
    };
};
